import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

const Login = () => {
  // 1. Renamed state from 'email' to 'username' for clarity
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login, token } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      // 3. Pass the username to the login function
      await login(username, password);
      // Navigation happens inside the login function
    } catch (err) {
      setError("Invalid username or password.");
      console.error(err);
    }
  };

  // If user is already logged in, redirect them from the login page
  if (token) {
    return <Navigate to="/extractions" />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen -mt-16 max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <form
          onSubmit={handleSubmit}
          className="bg-qtx-darker shadow-2xl rounded-lg px-8 pt-6 pb-8 mb-4"
        >
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold text-white">QUONTX PORTAL</h1>
            <p className="text-qtx-gray">Please sign in to continue</p>
          </div>
          <div className="mb-4">
            {/* 2. Updated label text and htmlFor attribute */}
            <label
              className="block text-qtx-light-gray text-sm font-bold mb-2"
              htmlFor="username"
            >
              Username
            </label>
            {/* 2. Changed input type to "text" and updated all related attributes */}
            <input
              className="w-full bg-qtx-dark border border-qtx-gray rounded py-2 px-3 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-qtx-blue"
              id="username"
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-qtx-light-gray text-sm font-bold mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              className="w-full bg-qtx-dark border border-qtx-gray rounded py-2 px-3 text-white leading-tight focus:outline-none focus:ring-2 focus:ring-qtx-blue"
              id="password"
              type="password"
              placeholder="******************"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="text-red-500 text-xs italic mb-4">{error}</p>}
          <div className="flex items-center justify-between">
            <button
              className="bg-qtx-blue hover:bg-blue-600 w-full text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Sign In
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
